function isPresignedUrl(url: string): boolean {
    try {
        const u = new URL(url);
        // Check for common S3 signed-URL params
        return (
            u.searchParams.has("X-Amz-Signature")
      && (u.searchParams.has("X-Amz-Expires") || u.searchParams.has("X-Amz-Date"))
        );
    } catch {
        return false;
    }
}

export function withConditionalCacheBust(url: string): string {
    if (!url) return url;
    if (isPresignedUrl(url)) {
        return url; // leave it alone
    }

    try {
        const u = new URL(url);
        // Add or update a version param
        u.searchParams.set("v", Date.now().toString());
        return u.toString();
    } catch {
    // if url is malformed, fallback to returning as is
        return url;
    }
}
